import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../reducers/rootReducer';

import { SET_VISIBLE_POPUP, SET_SELECTED_POPUP, SET_SELECTED_TOOL } from '../constants/popupConstants';

export default function PopupActions() {
    const dispatch = useDispatch();

    const isVisible = useSelector((state: RootState) => state.popupReducer.isVisible);
    const selectedPopup = useSelector((state: RootState) => state.popupReducer.selectedPopup);
    const selectedTool = useSelector((state: RootState) => state.popupReducer.selectedTool);

    const setViviblePopup: Function = (isVisible: boolean) => {
        dispatch({ type: SET_VISIBLE_POPUP, isVisible: isVisible });
    }

    const setSelectedPopup: Function = (popup: string) => {      
        dispatch({ type: SET_SELECTED_POPUP, selectedPopup: popup });
    }

    const setSelectedTool: Function = (tool: string) => {      
        dispatch({ type: SET_SELECTED_TOOL, selectedTool: tool });
    }

    const clearPopup: Function = (popup: string) => {   
        dispatch({ type: SET_VISIBLE_POPUP, isVisible: false });   
        dispatch({ type: SET_SELECTED_POPUP, selectedPopup: undefined });
    }

    return { isVisible, selectedPopup, selectedTool, setViviblePopup, setSelectedPopup, setSelectedTool, clearPopup }
}

